var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homework-video"},[_c('video',{staticClass:"video-js",attrs:{"id":_vm.playerId,"playsinline":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }